import React, { useEffect, useState } from "react";
import styles from "../CommonStyles/commonstyles.module.scss";
import { useNavigate } from "react-router-dom";
import uploadedImage from "../../../../assets/images/svg/noData.png";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
import { useDispatch, useSelector } from "react-redux";
import {
  useDeleteCertificate,
  useFetchAllCertificates,
} from "../../../../hooks/partnerHook/usePartnerCertificates";
import { RiDeleteBin5Line } from "react-icons/ri";
import { updateCertificateData } from "../../../../store/Partner/partnerDataSlice";
import noImageFound from "../../../../assets/images/svg/CertifcateCard.png";

const Certificates = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.partner.user);
  let partnerId = null;
  if (userData) {
    partnerId = userData.partner.id;
  }
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  const [certificates, setCertificates] = useState([]);

  const {
    data: certificateData,
    isError,
    isPending,
  } = useFetchAllCertificates(partnerId);
  const {
    mutate: deleteCertificate,
    isError: deletionError,
    isSuccess: certificateDeleted,
  } = useDeleteCertificate(navigate);

  useEffect(() => {
    if (certificateData) {
      dispatch(updateCertificateData(certificateData));
    }
  }, [dispatch, certificateData]);

  const savedCertificate = useSelector((state) => state.partner.certificates);

  useEffect(() => {
    if (savedCertificate) {
      setCertificates(savedCertificate);
    }
  }, [savedCertificate]);

  const handleDelete = () => {
    if (deleteId) {
      deleteCertificate({ partnerId, certificateId: deleteId });
      setShowDeleteModal(false);
    }
  };

  const formatDate = (isoDate) => {
    return new Date(isoDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (isPending) {
    return <h1>Loading...</h1>;
  }

  if (isError) {
    return <h1>Error...</h1>;
  }
  return (
    <>
      <div className={styles.dashboardContainer}>
        <h2 className={styles.browseEquipmentsTitle}>
          Browse All Certificates
        </h2>
        {certificates.length > 0 ? (
          <div className={styles.dashboardGridContainer}>
            {certificates.map((certificate) => (
              <div
                key={certificate.certificate_id}
                className={styles.certificateCard}
                onClick={() =>
                  navigate(
                    `/dashboard/certificates/${certificate.certificate_id}`
                  )
                }
              >
                <div className={styles.imageContainer}>
                <img
                    src={
                      certificate.media.length > 0
                        ? certificate.media[0].media_url
                        : noImageFound
                    }
                    alt={certificate.title}
                    className={styles.droneCardImg}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImageFound;
                    }}
                  />

                  <div
                    className={`${styles.verificationBadge} ${
                      certificate.verification_status === "success"
                        ? styles.verified
                        : styles.notVerified
                    }`}
                  >
                    {certificate.verification_status === "success" ? (
                      <>
                        <span className={styles.verifiedIcon}>Verified</span>
                      </>
                    ) : (
                      <>
                        <span className={styles.notVerifiedIcon}>
                          Not Verified
                        </span>
                      </>
                    )}
                  </div>
                </div>

                <div className={styles.bottomSection}>
                  <h3 className={styles.certificateTitle}>
                    {certificate.title}
                  </h3>
                  <button
                    className={styles.deleteButton}
                    onClick={(e) => {
                       e.stopPropagation(); 
                      setDeleteId(certificate.certificate_id);
                      setDeleteName(certificate.title);
                      setShowDeleteModal(true);
                    }}
                  >
                    <RiDeleteBin5Line />
                  </button>
                </div>
              </div>
            ))}

            {showDeleteModal && (
              <DeleteBox
                deleteFunction={handleDelete}
                isSuccess={certificateDeleted}
                isError={deletionError}
                contentName={deleteName}
                setShowDeleteModal={setShowDeleteModal}
              />
            )}
          </div>
        ) : (
          <div className={styles.noDataSection}>
            <img
              src={uploadedImage}
              alt="No Data"
              className={styles.noDataImage}
            />

            <h4 className={styles.noEquipmentText}>No Certificate added</h4>

            <p className={styles.noEquipmentDescription}>
              Highlight your specialized certifications to attract clients with
              specific project requirements.
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default Certificates;
